"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitTabsLabelsOnly = exports.UiKitTabs = exports.UiKitNumberInACircle = void 0;
const react_1 = require("@chakra-ui/react");
const consistency_1 = require("../../consistency");
const react_2 = __importStar(require("react"));
const UiKitContext_1 = require("../../UiKitContext");
const color_1 = require("../../color");
const UiKitNumberInACircle = (props) => {
    const sizeNum = props.size === undefined ? 26 : props.size;
    const size = `${sizeNum}px`;
    const radius = `${sizeNum / 2}px`;
    return (react_2.default.createElement(react_1.Box, { alignItems: "center", justifyContent: "center", style: {
            lineHeight: size,
            height: size,
            width: size,
            backgroundColor: props.backgroundColor ? props.backgroundColor : consistency_1.consistency.gray11100,
            color: props.color ? props.color : consistency_1.consistency.gray90,
            fontSize: props.fontSize || '11px',
            borderRadius: radius,
            textAlign: 'center',
            borderColor: props.borderColor
                ? props.borderColor
                : props.backgroundColor
                    ? props.backgroundColor
                    : consistency_1.consistency.gray11100,
            borderWidth: props.borderColor ? '1px' : 0,
        } }, props.number));
};
exports.UiKitNumberInACircle = UiKitNumberInACircle;
const UiKitTab = (props) => {
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const tabStyle = useNewBranding
        ? {
            outline: 'none',
            backgroundColor: props.selected
                ? color_1.brandColors.primaryButton.background
                : color_1.brandColors.table.headerBackground,
        }
        : {
            outline: 'none',
            backgroundColor: 'transparent',
        };
    return (react_2.default.createElement(react_1.Tab, { m: useNewBranding ? `0 ${consistency_1.consistency.smallBuffer} 0 0` : '0', p: `0 ${useNewBranding ? '0' : consistency_1.consistency.buffer} 0 0`, "data-cy": `cy-tab-${props.text.toLowerCase()}`, style: {
            ...tabStyle,
        }, _hover: {
            ...tabStyle,
            color: props.selected ? consistency_1.consistency.primaryBlue40 : consistency_1.consistency.gray70,
        }, _focus: {
            ...tabStyle,
        }, _selected: {
            ...tabStyle,
            color: props.selected ? consistency_1.consistency.primaryBlue40 : consistency_1.consistency.gray70,
        } },
        react_2.default.createElement(react_1.HStack, { align: 'center', p: '10px 8px', borderRadius: props.selected ? '0px' : consistency_1.consistency.borderRadius, borderBottom: useNewBranding
                ? undefined
                : props.selected
                    ? `2px solid ${consistency_1.consistency.primaryBlue50}`
                    : '2px solid transparent', _hover: {
                backgroundColor: props.selected
                    ? 'transparent'
                    : useNewBranding
                        ? color_1.brandColors.secondaryButton.hoverBackground
                        : consistency_1.consistency.gray04,
                color: props.selected ? consistency_1.consistency.primaryBlue40 : consistency_1.consistency.gray04,
            } },
            props.icon && props.icon.position === 'left' && props.icon.icon,
            props.number && (react_2.default.createElement(exports.UiKitNumberInACircle, { size: 18, number: parseInt(props.number), color: useNewBranding ? consistency_1.consistency.white : props.selected ? consistency_1.consistency.white : consistency_1.consistency.gray10000, backgroundColor: useNewBranding
                    ? color_1.brandColors.table.headerFont
                    : props.selected
                        ? consistency_1.consistency.primaryBlue50
                        : consistency_1.consistency.gray11110 })),
            react_2.default.createElement(react_1.Text, { fontSize: '12px', fontWeight: '400', color: props.selected
                    ? useNewBranding
                        ? consistency_1.consistency.white
                        : consistency_1.consistency.primaryBlue50
                    : consistency_1.consistency.gray70, _hover: {
                    color: props.selected
                        ? useNewBranding
                            ? consistency_1.consistency.white
                            : consistency_1.consistency.primaryBlue40
                        : consistency_1.consistency.gray70,
                }, m: "0" }, props.text.toUpperCase()),
            props.icon && props.icon.position === 'right' && props.icon.icon)));
};
const UiKitTabList = (props) => {
    return (react_2.default.createElement(react_1.TabList, { border: 'none', borderRadius: consistency_1.consistency.borderRadius, background: 'transparent', marginBottom: props.addMarginBottom ? consistency_1.consistency.buffer : '0' }, props.tabLabels.map((label, index) => {
        return (react_2.default.createElement(UiKitTab, { key: `${label}-${index}`, text: label, number: props.isNumbered ? `${index + 1}` : undefined, selected: props.selectedTabIndex === index, icon: props.icons ? props.icons[index] : undefined }));
    })));
};
const UiKitTabs = (props) => {
    return (react_2.default.createElement(UiKitTabsGeneric, { tabLabels: props.tabLabels, isNumbered: props.isNumbered, setSelectedTabIndex: props.setSelectedTabIndex, selectedTabIndex: props.selectedTabIndex, isLazy: props.isLazy, icons: props.icons },
        react_2.default.createElement(react_1.TabPanels, { borderRadius: consistency_1.consistency.halfBuffer }, props.children)));
};
exports.UiKitTabs = UiKitTabs;
exports.UiKitTabs.TabPanel = (props) => react_2.default.createElement(react_1.TabPanel, { ...props });
const UiKitTabsLabelsOnly = (props) => {
    return (react_2.default.createElement(UiKitTabsGeneric, { tabLabels: props.tabLabels, isNumbered: props.isNumbered, setSelectedTabIndex: props.setSelectedTabIndex, selectedTabIndex: props.selectedTabIndex }));
};
exports.UiKitTabsLabelsOnly = UiKitTabsLabelsOnly;
const UiKitTabsGeneric = (props) => {
    return (react_2.default.createElement(react_1.Tabs, { border: 'none', variant: "enclosed", size: "md", onChange: index => props.setSelectedTabIndex(index), index: props.selectedTabIndex, isLazy: !!props.isLazy },
        react_2.default.createElement(UiKitTabList, { tabLabels: props.tabLabels, isNumbered: props.isNumbered, selectedTabIndex: props.selectedTabIndex, addMarginBottom: !!props.children, icons: props.icons }),
        props.children));
};
